import { Space, Spin } from "antd";
const Loader = () => (
  // <Space size="middle" style={{marginTop:"25%"}}>
    <Spin  size="large" className="text-[#006eff]"  >
    <div className="content" />
    </Spin>
  // </Space>
);
export default Loader;
